import { IApplicationState } from '../../types/redux';

export const selectAllCount = (state: IApplicationState) => state.results.total;
